import * as _m0 from "protobufjs/minimal";
import { Long } from "@osmonauts/helpers";
function createBaseValidator() {
  return {
    name: "",
    address: "",
    weight: Long.UZERO,
    delegation: "",
    slashQueryProgressTracker: "",
    slashQueryCheckpoint: "",
    internalSharesToTokensRate: "",
    delegationChangesInProgress: Long.ZERO,
    slashQueryInProgress: false
  };
}
export const Validator = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.address !== "") {
      writer.uint32(18).string(message.address);
    }
    if (!message.weight.isZero()) {
      writer.uint32(48).uint64(message.weight);
    }
    if (message.delegation !== "") {
      writer.uint32(42).string(message.delegation);
    }
    if (message.slashQueryProgressTracker !== "") {
      writer.uint32(74).string(message.slashQueryProgressTracker);
    }
    if (message.slashQueryCheckpoint !== "") {
      writer.uint32(98).string(message.slashQueryCheckpoint);
    }
    if (message.internalSharesToTokensRate !== "") {
      writer.uint32(82).string(message.internalSharesToTokensRate);
    }
    if (!message.delegationChangesInProgress.isZero()) {
      writer.uint32(88).int64(message.delegationChangesInProgress);
    }
    if (message.slashQueryInProgress === true) {
      writer.uint32(104).bool(message.slashQueryInProgress);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidator();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.name = reader.string();
          break;
        case 2:
          message.address = reader.string();
          break;
        case 6:
          message.weight = reader.uint64();
          break;
        case 5:
          message.delegation = reader.string();
          break;
        case 9:
          message.slashQueryProgressTracker = reader.string();
          break;
        case 12:
          message.slashQueryCheckpoint = reader.string();
          break;
        case 10:
          message.internalSharesToTokensRate = reader.string();
          break;
        case 11:
          message.delegationChangesInProgress = reader.int64();
          break;
        case 13:
          message.slashQueryInProgress = reader.bool();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$name, _object$address, _object$delegation, _object$slashQueryPro, _object$slashQueryChe, _object$internalShare, _object$slashQueryInP;
    const message = createBaseValidator();
    message.name = (_object$name = object.name) !== null && _object$name !== void 0 ? _object$name : "";
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    message.weight = object.weight !== undefined && object.weight !== null ? Long.fromValue(object.weight) : Long.UZERO;
    message.delegation = (_object$delegation = object.delegation) !== null && _object$delegation !== void 0 ? _object$delegation : "";
    message.slashQueryProgressTracker = (_object$slashQueryPro = object.slashQueryProgressTracker) !== null && _object$slashQueryPro !== void 0 ? _object$slashQueryPro : "";
    message.slashQueryCheckpoint = (_object$slashQueryChe = object.slashQueryCheckpoint) !== null && _object$slashQueryChe !== void 0 ? _object$slashQueryChe : "";
    message.internalSharesToTokensRate = (_object$internalShare = object.internalSharesToTokensRate) !== null && _object$internalShare !== void 0 ? _object$internalShare : "";
    message.delegationChangesInProgress = object.delegationChangesInProgress !== undefined && object.delegationChangesInProgress !== null ? Long.fromValue(object.delegationChangesInProgress) : Long.ZERO;
    message.slashQueryInProgress = (_object$slashQueryInP = object.slashQueryInProgress) !== null && _object$slashQueryInP !== void 0 ? _object$slashQueryInP : false;
    return message;
  }
};